import { z } from 'zod';

export const AdSchema = z.object({
  id: z.string().optional(),
  active: z.boolean(),
  type: z.string(),
  url: z.string(),
  title: z.string(),
  src: z.string(),
  vendor: z.string().optional(),
  // When true, the creative already has its own baked-in text/CTA — skip the
  // live title-overlay caption to avoid rendering text on top of text.
  hideOverlay: z.boolean().optional()
});

export type AdType = z.infer<typeof AdSchema>;
